/*
 * Module for the Add Employer Page
*/

rs.module("employer/addemployer",

    ["common/select-helper"],

    function (selectHelper) {

        var _jsSelectors;
        var _cssClasses;
        var _form;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, duplicateEmployerLookup) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;

            _form = $.js(_jsSelectors.form);

            // Register click event for changing employer identity once an identity has previously been verified
            _form.js(_jsSelectors.changeIdentityLink).click(function () { _togglePageForIdentityVerified(false); });

            // Tell duplicate employer lookup where to pull lookup parameters from
            duplicateEmployerLookup.onGetLookupParameters(function () {

                // Validate form before performing duplicate lookup
                var validator = _form.validate();
                var isValid = validator.form();

                // only send lookup parameters if form is valid
                if (isValid) {
                    return {
                        employerName: _form.js(_jsSelectors.employerName).val().trim(),
                        fein: _form.js(_jsSelectors.fein).val().replace(/-/g, "").replace(/ /g, ""),
                        employerID: _form.js(_jsSelectors.employerID).val().trim(),
                    }
                }

                return null;
            });

            // Hookup callback function to be executed when duplicate popup is closed
            duplicateEmployerLookup.onDuplicatePopupClosed(_duplicatePopupClosed);
        }

        //
        // Callback to execute when duplicate popup is closed
        //
        function _duplicatePopupClosed() {

            // set hidden fields to be able to post values back on save since we will be disabling the identity fields
            _form.js(_jsSelectors.employerNameHidden).val(_form.js(_jsSelectors.employerName).val().trim());
            _form.js(_jsSelectors.feinHidden).val(_form.js(_jsSelectors.fein).val().trim());
            _form.js(_jsSelectors.employerIDHidden).val(_form.js(_jsSelectors.employerID).val().trim());

            _togglePageForIdentityVerified(true);
           
            // Move focus to Reporting Method select for quicker data entry
            _form.js(_jsSelectors.reportingMethodSelect).focus();
        }
        
        //
        // Enable/disable sections based on whether employer identity has been verified
        //
        function _togglePageForIdentityVerified(identityVerified) {

            _form.js(_jsSelectors.identityVerified).val(identityVerified);
            _form.js(_jsSelectors.saveButton).setDisabled(!identityVerified);

            _toggleIdentitySection(!identityVerified);
            _toggleDetailSection(identityVerified);
            _toggleContactInfoSection(identityVerified);

            _resetValidations();
        }

        //
        // Enable/disable the identity section
        //
        function _toggleIdentitySection(enable) {

            _toggleSectionFields(_jsSelectors.identity, enable);

            _form.js(_jsSelectors.duplicateEmployerLookup).toggle(enable);
            _form.js(_jsSelectors.changeIdentityLink).toggleClass(_cssClasses.visible, !enable);
        }  

        //
        // Enable/disable the detail section
        //
        function _toggleDetailSection(enable) { 
            
            _toggleSectionFields(_jsSelectors.detail, enable);
        }

        //
        // Enable/disable the Contact Info section
        //
        function _toggleContactInfoSection(enable) {
  
            _toggleSectionFields(_jsSelectors.contactInfo, enable);

            // Certain Address, Phone and Email inputs are unique, we always want data-val=false due to the conditional nature of their validations
            _form.js(_jsSelectors.addressInput, { multiple: true }).attr("data-val", false);
            _form.js(_jsSelectors.phoneInput, { multiple: true }).attr("data-val", false);
            _form.js(_jsSelectors.emailInput, { multiple: true }).attr("data-val", false);
        }

        //
        // Helper method to enable/disable all fields in a section
        //
        function _toggleSectionFields(sectionSelector, enable) {

            // enable/disable all non-hidden inputs in the section
            _form.js(sectionSelector).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable).clearErrors();

            // Have to use select helper to handle any selects
            _form.js(sectionSelector).find("select").each(function () {
                $(this).attr("data-val", enable).clearErrors();
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });
        }
            
        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {
            $.validator.resetValidation(_form);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);